import { Avatar } from 'antd';
import React, {
  memo, //useState
} from 'react';
import css from './TopHeader.module.less';
//import Logo from '../../static/svg/logo.svg';
import { getLoginDomain, userLogout } from 'src/tools/getUserInfo';
// import { changeSiderPosition } from '../store';
// import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@/src/tools/icon';
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  // AppstoreOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import {
  useLocalStorageState, //useUpdateEffect
} from 'ahooks';
import { get } from 'lodash';
import { CustomerService } from 'src/components/CustomerServiceModal';
import { useI18n } from 'src/hooks/useRouterChange';
import { ACCOUNT_INFO as _ACCOUNT_INFO } from 'src/tools/constant';
import {
  //checkIsLoginExpire,
  generateKey,
} from 'src/tools/getUserInfo';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import {
  I18nContext,
  languageLabel,
  languageList,
} from '../../../locale/IntlProvider/IntlProvider';
import DropDown from '../../components/Antd/DropDown/DropDown';

interface IProps {
  userName: string;
}
const LanguageSelect = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setLang, lang, setReloading } = React.useContext(I18nContext);

  return (
    <React.Fragment>
      <div className={css.avatarDropdownContainer}>
        {languageList.map((i) => {
          return (
            <div
              className={`${css.avatarItem} ${
                lang === i ? css.selected : null
              }`}
              key={i}
              onClick={() => {
                if (lang === i) {
                  return false;
                }
                modal.error({
                  title: replaceI18nVariables(
                    getI18n('general.changeLanguageTitle'),
                    languageLabel[i],
                  ),
                  content: replaceI18nVariables(
                    getI18n('general.changeLanguageContent'),
                    languageLabel[i],
                  ),
                  onOkText: getI18n('general.confirm'),
                  onOk: () => {
                    setReloading(true);
                    if (lang !== i) {
                      setLang(i);
                    }
                  },
                });
              }}>
              <span>{languageLabel[i]}</span>
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};
const TopHeader = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const loginDomain = getLoginDomain();
  const k = generateKey(_ACCOUNT_INFO);
  const [info] = useLocalStorageState<any>(k);
  const storeName = get(info, 'storeName');
  // const storeUuid = get(info, 'storeUuid');
  // const state = useSelector((state: any) => state.mainLayout);
  // const dispatch = useDispatch();
  const { userName } = props;
  const processName = React.useMemo(() => {
    if (userName) {
      const arr = userName.split(' ');
      const name = arr.map((i: any) => {
        const f = (i || '').substr(0, 1);
        return f;
      });
      return name.join('');
    }
    return '';
  }, [userName]);

  // useUpdateEffect(() => {

  // }, [storeUuid]);
  //const storeName = getStoreName();
  //const [layoutValue, setLayoutValue] = useState('Fixed width');
  // const layoutSet = [
  //   //模拟数据
  //   {
  //     value: state.position,
  //     name: 'Navigation Style',
  //     radio: ['Vertical', 'Hotizontal'],
  //     function: (e) => {
  //       dispatch(
  //         changeSiderPosition({
  //           position: e.target.value,
  //         }),
  //       );
  //     },
  //   },
  //   {
  //     value: layoutValue,
  //     name: 'Layout',
  //     radio: ['Fixed width', 'Full screen width'],
  //     function: (e) => setLayoutValue(e.target.value),
  //   },
  // ];

  // const plusSquareClick = () => {
  //   return;
  // }; //点击下拉列表的标题事件
  // const renderOverlay = (
  //   name,
  //   data,
  //   title,
  //   paddingRow, //带大标题的下拉列表
  // ) => (
  //   <div className={css.plusSquare}>
  //     <div
  //       className={css.plusSquareTitle}
  //       style={{ padding: `0 ${paddingRow}px` }}
  //       onClick={plusSquareClick}>
  //       <span className={css.setResetText}>{title}</span>
  //     </div>
  //     {setItem(name, data)}
  //   </div>
  // );

  const renderAvatarOverlay = () => (
    <div className={css.avatarDropdownContainer}>
      <div
        className={css.avatarItem}
        onClick={() => {
          // userLogout();
          window.location.href = `${loginDomain}/profile`;
        }}>
        <span>{getI18n('general.myProfile')}</span>
      </div>
      <div
        className={css.avatarItem}
        onClick={() => {
          // userLogout();
          window.location.href = `${loginDomain}`;
        }}>
        <span>{getI18n('general.stores')}</span>
      </div>
      <div
        className={`${css.avatarItem} ${css.logout}`}
        onClick={() => {
          userLogout();
          window.location.href = `${loginDomain}/login`;
        }}>
        <span>{getI18n('general.logout')}</span>
      </div>
    </div>
  );
  // const appstoreOverlay = <div>111111</div>; //暂时保留，后期添加
  //const globalOverlay = <div>22222</div>; //暂时保留，后期添加

  const topMenuLsit = [
    {
      //顶部ICON列表配置
      icon: (
        <div className={css.headerIconAndText}>
          <Icon type='iconservice' className={css.topHeaderIcon1} />
          {getI18nFromGeneral('general.customerServiceModal.support')}
        </div>
      ),
      overlayItemClassName: css.className,
      overlay: <CustomerService />,
    },
    // {
    //   icon: <AppstoreOutlined className={css.topHeaderIcon} />,
    //   className: css.plusSquareContiner,
    //   overlay: appstoreOverlay,
    // },
    {
      icon: <GlobalOutlined rev className={css.topHeaderIcon} />,
      className: css.plusSquareContiner,
      overlay: <LanguageSelect />,
    },
    // {
    //   icon: <LayoutOutlined className={css.topHeaderIcon} />,
    //   className: css.plusSquareContiner,
    //   overlay: renderOverlay(
    //     'LayoutOut',
    //     layoutSet,
    //     'Customize appearance',
    //     24,
    //   ),
    // },
  ];
  return (
    <div className={css.topHeader} id='tcPortalHeader'>
      <div className={css.topHeaderLeft}>
        <div className={css.topHeaderLeftImg}>
          <img src={'https://resource2.unifyxp.com/icon/logo.svg'} />
        </div>
        <p className={css.storeName}>{storeName}</p>
      </div>

      <div className={css.topHeaderRight}>
        {topMenuLsit.map((item, index) => (
          <DropDown
            key={index}
            overlay={item.overlay}
            trigger={['click']}
            placement='bottomRight'
            overlayClassName={item.className}
            overlayItemClassName={item.overlayItemClassName}>
            {item.icon}
          </DropDown>
        ))}
        {userName && (
          <div className={css.topHeaderAvatarContain}>
            <DropDown
              overlay={renderAvatarOverlay()}
              trigger={['click']}
              placement='bottomRight'
              // overlayClassName={item.className}
            >
              <Avatar className={css.topHeaderAvatar} size={40}>
                {processName}
              </Avatar>
            </DropDown>
          </div>
        )}
      </div>
    </div>
  );
};
export default memo(TopHeader);
